<div class="upload-parent">
  <div class="detail">
    <div>{{streetAddres}}</div>
    <div>{{progress}}%</div>
  </div>
  <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
</div>
<style>
  .upload-parent .mat-progress-bar {
    height: 4px !important;
  }
  .detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 0 !important;
  }
</style>
